import {
  ProductFormInterface,
  ValidationSet
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const ProductValidationSet: ValidationSet<ProductFormInterface> = {
  productName: commonValidations.productName,
  request_option_ids: commonValidations.productChangeValue,
  productNameGerman: commonValidations.productNameGerman,
  is_allow_negative_amount: [],
  is_archived: [],
  application_type: commonValidations.applicationType,
  refund_policy: []
};
